// extracted by mini-css-extract-plugin
export default {"modal":"GroupFormModal_modal__VruT2","content":"GroupFormModal_content__2TMfZ","title":"GroupFormModal_title__SUc9w","actions":"GroupFormModal_actions__+P3lJ"};